import * as Type from './actionsTypes';

const findRequisicaoById = (id) => ({ type: Type.REQUISICAO_FIND_ONE, id });

const requisicaoClearSelected = () => ({ type: Type.REQUISICAO_CLEAR_SELECTED });

const fetchRequisicaoCatalogo = () => ({ type: Type.REQUISICAO_FETCH_CATALOGO });

const createRequisicao = (data, callback) => ({
  type: Type.REQUISICAO_CREATE,
  data,
  callback,
});

const updateRequisicao = (id, data, callback) => ({
  type: Type.REQUISICAO_UPDATE,
  id,
  data,
  callback,
});

const deleteRequisicao = (id, callback) => ({
  type: Type.REQUISICAO_DELETE,
  id,
  callback,
});

const aprovarRequisicaoParcial = (id, data, callback) => ({
  type: Type.REQUISICAO_APROVAR_PARCIAL,
  id,
  data,
  callback,
});

const cancelarRequisicao = (id, data, callback) => ({
  type: Type.REQUISICAO_CANCELAR,
  id,
  data,
  callback,
});

const criarRequisicaoEntregas = (id, data, callback) => ({
  type: Type.REQUISICAO_CRIAR_ENTREGAS,
  id,
  data,
  callback,
});

const atualizarRequisicaoEntrega = (id, data, callback) => ({
  type: Type.REQUISICAO_ATUALIZAR_ENTREGA,
  id,
  data,
  callback,
});

const cancelarRequisicaoEntrega = (id, callback) => ({
  type: Type.REQUISICAO_CANCELAR_ENTREGA,
  id,
  callback,
});

const despacharRequisicaoEntrega = (id, data, callback) => ({
  type: Type.REQUISICAO_DESPACHAR_ENTREGA,
  id,
  data,
  callback,
});

const finalizarRequisicaoEntrega = (id, callback) => ({
  type: Type.REQUISICAO_FINALIZAR_ENTREGA,
  id,
  callback,
});

const registrarRequisicaoRastreamento = (id, data, callback) => ({
  type: Type.REQUISICAO_RASTREAMENTO,
  id,
  data,
  callback,
});

const receberRequisicaoPedido = (id, callback) => ({
  type: Type.REQUISICAO_PEDIDO_RECEBER,
  id,
  callback,
});

const cancelarRequisicaoPedido = (id, data, callback) => ({
  type: Type.REQUISICAO_PEDIDO_CANCELAR,
  id,
  data,
  callback,
});

const fetchRequisicaoItemDisponibilidade = (requisicaoId, itemId) => ({
  type: Type.REQUISICAO_FETCH_DISPONIBILIDADE,
  requisicaoId,
  itemId,
});

const requisicaoClearDisponibilidade = () => ({
  type: Type.REQUISICAO_CLEAR_DISPONIBILIDADE,
});

export {
  findRequisicaoById,
  requisicaoClearSelected,
  fetchRequisicaoCatalogo,
  createRequisicao,
  updateRequisicao,
  deleteRequisicao,
  aprovarRequisicaoParcial,
  cancelarRequisicao,
  criarRequisicaoEntregas,
  atualizarRequisicaoEntrega,
  cancelarRequisicaoEntrega,
  despacharRequisicaoEntrega,
  finalizarRequisicaoEntrega,
  registrarRequisicaoRastreamento,
  receberRequisicaoPedido,
  cancelarRequisicaoPedido,
  fetchRequisicaoItemDisponibilidade,
  requisicaoClearDisponibilidade,
};
